import { EGroupedItemsType } from '~/src/services/properties';

export const textCustomize = {
    name: 'customize',
    label: 'Настройки текста',
    order: 1,
    items: {
        font: {
            name: 'font',
            label: 'Шрифт',
            type: EGroupedItemsType.Select,
        },
        tag: {
            name: 'tag',
            label: 'Тег',
            type: EGroupedItemsType.Select,
        },
        color: {
            name: 'fontSize',
            label: 'Цвет:',
            type: EGroupedItemsType.ColorPicker,
        },
        textAlign: {
            name: 'textAlign',
            label: 'Выравнивание:',
            type: EGroupedItemsType.TextAlignment,
        },
    },
};
